import { type Dispatch, type SetStateAction, useEffect, useState } from "react";
import styles from "./ProductIbpt.module.css";

import { useQuery } from "@tanstack/react-query";
import { currentProductIbpt, productIbpt } from "../../../../../services/products";
import { type productIBPT } from "../../../../../types/products";
import InputSuspense from "../../../../../components/InputSuspense/InputSuspense";

const ProductIbpt = ({
  valueDropDown,
  setValueDropDown,
  style,
  disabled,
  readOnly,
}: {
  valueDropDown: string;
  setValueDropDown: Dispatch<SetStateAction<string>>;
  style: React.CSSProperties;
  disabled?: boolean;
  readOnly?: boolean;
}) => {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(false);

  const { data: currentProduct } = useQuery({
    queryKey: ["currentProductIbpt", valueDropDown],
    queryFn: () => currentProductIbpt(valueDropDown || ""),
    enabled: !!valueDropDown,
    refetchOnWindowFocus: false,
  });

  const { data } = useQuery({
    queryKey: ["productIbpt", debouncedSearch],
    queryFn: () => productIbpt(debouncedSearch),
  });

  const handleClickP = (uid: string, title: string) => {
    setValueDropDown(uid);
    setSearch(title);
    setActiveDropdown(false);
  };

  useEffect(() => {
    if (valueDropDown && currentProduct) {
      const filterValue = `${currentProduct.ncm} | ${currentProduct.titulo}`;
      setSearch(filterValue);
    }
  }, [valueDropDown, currentProduct]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [search]);

  return (
    <div className={styles.selectProduct} style={style}>
      <div className={styles.customSelect}>
        <InputSuspense
          label="Produto na tabela IBPT"
          placeholder={disabled ? "" : "Selecione um produto"}
          name="ibpt"
          onChange={(e: any) => setSearch(e.target.value)}
          value={search}
          isActiveDropDown={activeDropdown}
          setIsActiveDropDown={setActiveDropdown}
          disabled={disabled}
          readOnly={readOnly}
          option={
            <div className={styles.optionInput}>
              {data &&
                data.map((product: productIBPT) => (
                  <p
                    key={product.uid_produto_ibpt}
                    onClick={() =>
                      handleClickP(product.uid_produto_ibpt, `${product.ncm} | ${product.titulo}`)
                    }
                    className={styles.optionItens}>
                    <span>{product.ncm}</span> <span>{product.titulo}</span>
                  </p>
                ))}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ProductIbpt;
